/** @jsx jsx **/
import { jsx } from "@emotion/react";
import React from "react";

import { checkWebView } from "@func";
import logoImg from "@images/logo.png";

import * as styles from "./header.style";

const Header = () => {
  const isWebView = checkWebView();

  return (
    <header>
      {!isWebView && (
        <>
          <div css={styles.logo}>
            <a href="https://www.myrealtrip.com/">
              <img css={styles.logoImg} src={logoImg} alt="logo" />
            </a>
          </div>
          <div css={styles.border}></div>
        </>
      )}
    </header>
  );
};

export default Header;
